/** A partir deste total, exige digitar a quantidade para confirmar. */

export const BULK_TYPE_CONFIRM_THRESHOLD = 5;



/** A partir deste total, exige segundo checkbox de revisão da lista. */

export const BULK_REVIEW_ACK_THRESHOLD = 25;



/** A partir deste total, exige digitar a palavra de confirmação. */

export const BULK_PHRASE_CONFIRM_THRESHOLD = 100;



export const BULK_CONFIRM_PHRASE = "CONFIRMAR";



/**

 * Níveis de confirmação (crescente com a quantidade impactada):

 * 0 — apenas checkbox principal

 * 1 — digitar quantidade

 * 2 — + checkbox de revisão dos IDs

 * 3 — + digitar palavra CONFIRMAR

 *

 * @param {number} count

 * @param {{ forceTypedConfirmation?: boolean, minLevel?: number }} [options]

 */

export function getConfirmationRequirements(count, options = {}) {

  const n = Number(count) || 0;

  const { forceTypedConfirmation = false, minLevel = 0 } = options;



  let level = Math.max(0, minLevel);

  if (forceTypedConfirmation || n >= BULK_TYPE_CONFIRM_THRESHOLD) level = Math.max(level, 1);

  if (n >= BULK_REVIEW_ACK_THRESHOLD) level = Math.max(level, 2);

  if (n >= BULK_PHRASE_CONFIRM_THRESHOLD) level = Math.max(level, 3);



  return {

    level,

    requireTypedCount: level >= 1,

    requireReviewAck: level >= 2,

    requirePhrase: level >= 3,

    confirmPhrase: BULK_CONFIRM_PHRASE,

    isHighImpact: n >= BULK_REVIEW_ACK_THRESHOLD,

    isCriticalImpact: n >= BULK_PHRASE_CONFIRM_THRESHOLD,

  };

}



export function getConfirmationLevelLabel(level) {

  switch (level) {

    case 0:

      return "Padrão";

    case 1:

      return "Elevado";

    case 2:

      return "Alto";

    case 3:

      return "Crítico";

    default:

      return "Padrão";

  }

}



/** @deprecated use getConfirmationRequirements */

export function needsTypedConfirmation(count) {

  return getConfirmationRequirements(count).requireTypedCount;

}



/** @deprecated use getConfirmationRequirements */

export function isHighImpactSelection(count) {

  return getConfirmationRequirements(count).isHighImpact;

}



export function getConfirmationLevelLabelFeminine(level) {
  switch (level) {
    case 0:
      return "padrão";
    case 1:
      return "elevada";
    case 2:
      return "alta";
    case 3:
      return "crítica";
    default:
      return "padrão";
  }
}

/** Texto: "N entidade(s) será(ão) {verbo}" */
export function formatBulkImpactCount(count, impactVerb, entity = {}) {
  const n = Number(count) || 0;
  const singular = entity.singular || "solicitação";
  const plural = entity.plural || "solicitações";
  if (n === 1) {
    return `1 ${singular} será ${impactVerb}`;
  }
  return `${n} ${plural} serão ${impactVerb}`;
}

export function formatBulkIdPreview(ids, maxShow = 12) {

  const list = Array.isArray(ids) ? ids : [];

  if (!list.length) return "—";

  const shown = list.slice(0, maxShow);

  const rest = list.length - shown.length;

  if (rest > 0) {

    return `${shown.join(", ")} e mais ${rest}`;

  }

  return shown.join(", ");

}



/**

 * @typedef {{ label: string, value: string, severity?: 'warning' | 'error' }} BulkChangeLine

 */

